export const emptyCopilotTabsTemplateData = {
  user: {
    avatarText: '',
    name: '',
    country: '',
    travelerSummary: '',
    customerType: '',
      duration: '',
      departureDate: '',
      orderId: '',
      whatsappPhoneNumber: '',
      customerRequest: [],
  },
  orderDetailLines: [],
  analysis: null,
  updatedAt: '',
}

const parseUpdatedAt = (runMeta) => {
  const [, year, month, day, hour, minute] = runMeta?.snapshot_generated_at?.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/) || []
  return year ? `${year}年${month}月${day}日 ${hour}:${minute}` : ''
}

export const extractInsightJson = (profile) => {
  if (!profile || profile.milestone !== 'V5' || !profile.insight_json) {
    return null
  }
  try {
    return typeof profile.insight_json === 'string' ? JSON.parse(profile.insight_json) : profile.insight_json
  } catch (error) {
    return null
  }
}

export const buildCopilotTabsTemplateData = (v5Output) => {
  if (!v5Output || typeof v5Output !== 'object') {
    return emptyCopilotTabsTemplateData
  }

  const { header = {}, run_metadata: runMeta } = v5Output

  return {
    ...v5Output,
    updatedAt: parseUpdatedAt(runMeta),
    user: {
      avatarText: header.initials || '',
      name: (header.customer_display_name || '').trim(),
      country: header.country_or_region || '',
      travelerSummary: header.party_summary || '',
      customerType: header.customer_type || '',
      duration: header.duration_label || '',
      departureDate: header.departure_label || '',
      orderId: header.order_id || '',
      whatsappPhoneNumber: '',
      customerRequest: Array.isArray(header.customer_requirements) ? header.customer_requirements : header.customer_requirements ? [header.customer_requirements] : [],
    },
    orderDetailLines: [],
  }
}
